module.exports = __webpack_public_path__ + "img/ressourcesbg.586798f4.png";